module.exports = __webpack_public_path__ + "static/img/17032414219895269323798.f041434.jpeg";


//////////////////
// WEBPACK FOOTER
// ./static/default/upload/work/20231222/17032414219895269323798.jpeg
// module id = WOaM
// module chunks = 7